// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"o2-z","displaySixCardTiles":"p2-z"};